import { Numeric9CircleIcon } from './Numeric9CircleIcon';

/**
 * author: Contributors
 * id FB06011B-B2CC-4F3A-8ADE-2F7E78F0AE7C
 * name numeric-9-circle
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/numeric-9-circle.svg
 * tags
 * - Alpha / Numeric 
 */
export const NumberNineCircleIcon = Numeric9CircleIcon;
export default NumberNineCircleIcon